// src/app/job-description-model-popup/job-description-model-popup.component.ts
//Beautification Adding Double Quotes is Good Practice

import {Component, Input, ViewChild,ElementRef,HostListener,ViewChildren,QueryList,} from "@angular/core";
import { CommonModule } from "@angular/common";
import { WidgetInput } from "../Models/job-like-job.model";
import {StripHtmlPipe,SafeEmbedHtmlPipe,} from "../pipes/Angular-commonUtil.pipe";



@Component({
  selector: "job-description-model-popup",
  standalone: true,
  imports: [CommonModule, StripHtmlPipe, SafeEmbedHtmlPipe],
  templateUrl: "./job-description-model-popup.component.html",
  styleUrls: ["./job-description-model-popup.component.scss"],
})
export class JobDescriptionModelPOPUPComponent {
  @ViewChild("modalContent") modalContent!: ElementRef;
  @ViewChild("modalStart") closeButton!: ElementRef;
  @ViewChildren("accordionItem", { read: ElementRef })
  accordionItems!: QueryList<ElementRef>;
  @ViewChild("modalContainer") modalContainer!: ElementRef;
  @ViewChildren("accordionBody", { read: ElementRef }) accordionBodies!: QueryList<ElementRef>;

  pagetype: string = "";
  translateStrings: any = {};
  jobdescpritionAndTitle: {
    JobTitle: string;
    JobDescription: string;
    Clicked:number;
  }[] = [];
  expandedJobIndex: number | null = null;
  showModal: boolean = false;
  modalReady: boolean = false;
  @Input() set widgetData(data: WidgetInput) {
    this.translateStrings = data.TranslateStrings || {};
    this.jobdescpritionAndTitle = data.jobInformation || [];
    this.pagetype =data.pagetype;
    const hasValidJob = this.jobdescpritionAndTitle.some(
      (item) => item?.JobTitle && item?.JobDescription?.trim()
    );

    this.showModal = hasValidJob;
    if (hasValidJob) {
      setTimeout(() => {
        this.modalReady = true;
        this.setupFocusTrap();
        if (this.closeButton) {
          this.closeButton.nativeElement.focus();
        }
      }, 0);
    }

    const index = this.jobdescpritionAndTitle.findIndex(
      (item) => item.Clicked === 1
    );
    if (index !== -1 && index < this.jobdescpritionAndTitle.length) {
      setTimeout(() => {
        this.toggleAccordion(index);
      }, 500); // Ensures DOM elements (like accordion bodies) are ready
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showModal || !this.modalReady) return;

    const clickedInside = this.modalContent?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.closeModal();
    }
  }

  @HostListener("document:keydown.escape", ["$event"])
  onEscapeKey(event: KeyboardEvent): void {
    this.closeModal();
  }
  toggleAccordion(index: number): void {
    const wasExpanded = this.expandedJobIndex === index;
    this.expandedJobIndex = wasExpanded ? null : index;
    setTimeout(() => {
      if (!wasExpanded) {
        const modalEl = this.modalContent?.nativeElement;
        const bodyEl = this.accordionBodies?.get(index)?.nativeElement;
        if (!bodyEl) {
          console.warn("Accordion body not found at index", index);
          return;
        }
        const modalRect = modalEl.getBoundingClientRect();
        const bodyRect = bodyEl.getBoundingClientRect();
        const offset = bodyRect.top - modalRect.top;
        if (modalEl && bodyEl) {
          const targetScrollTop = modalEl.scrollTop + offset - 20;
          this.scrollToFast(modalEl, targetScrollTop, 200); // 200ms = fast and smooth
        }
        setTimeout(() => {
          const descEl = document.getElementById(`jobDesc-${index}`) as HTMLElement | null;
          if (descEl) {
            descEl.setAttribute('tabindex', '0');
            descEl.focus({ preventScroll: true });
          }
          this.setupFocusTrap();
        }, 350);
      } else {
        setTimeout(() => {
          const descEl = document.getElementById(`jobDesc-${index}`) as HTMLElement | null;
          if (descEl) {
            descEl.setAttribute('tabindex', '-1');
          }
          this.setupFocusTrap();
          const headerEl = document.getElementById(`accordion-header-${index}`) as HTMLElement | null;
          if (headerEl) {
            headerEl.setAttribute('tabindex', '0');
            setTimeout(() => {
              headerEl.focus({ preventScroll: true });
            }, 50);
          }
        }, 100);
      }
    }, 350);
  }
  scrollToFast(
    container: HTMLElement,
    targetTop: number,
    duration: number = 300
  ) {
    const start = container.scrollTop;
    const change = targetTop - start;
    const startTime = performance.now();

    const animateScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      container.scrollTop = start + change * progress;

      if (elapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }

  jobdescriptionhandleKeydown(event: KeyboardEvent, index: number): void {
    this.toggleAccordion(index);
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
    }
  }

  private setupFocusTrap(): void {
    if (!this.modalContent) return;
    if (this.modalContent.nativeElement._trap) {
      this.modalContent.nativeElement.removeEventListener("keydown", this.modalContent.nativeElement._trap);
    }
    const focusable = this.modalContent.nativeElement.querySelectorAll(
      'button:not([hidden]):not([disabled]), [href]:not([hidden]):not([disabled]), input:not([hidden]):not([disabled]), select:not([hidden]):not([disabled]), textarea:not([hidden]):not([disabled]), [tabindex]:not([tabindex="-1"]):not([hidden]):not([disabled])'
    ) as NodeListOf<HTMLElement>;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const trap = (e: KeyboardEvent) => {
      if (e.key !== "Tab" || !this.showModal || !this.modalReady) return;
      const activeElement = document.activeElement as HTMLElement;
      if (!this.modalContent.nativeElement.contains(activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (e.shiftKey && activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    this.modalContent.nativeElement.addEventListener("keydown", trap);
    this.modalContent.nativeElement._trap = trap;
  }

  closeModal(): void {
    this.showModal = false;
    this.modalReady = false;
    if (this.modalContent?.nativeElement._trap) {
      this.modalContent.nativeElement.removeEventListener("keydown", this.modalContent.nativeElement._trap);
      delete this.modalContent.nativeElement._trap;
    }
    const lastIndex = (window as any).lastFocusedJobIndex;
    if (lastIndex !== undefined) {
      setTimeout(() => {
        const jobTitleEl = document.getElementById(`jobTitle ${lastIndex}`);
        if (jobTitleEl) {
          jobTitleEl.setAttribute("tabindex", "0"); // ensure tabbable
          jobTitleEl.focus();
        }
      }, 200);
    }
  }
}
